module.exports = __webpack_public_path__ + "6ddda3523d20e8ba31399147bdaa277a.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/icons/cursors/circles/png/circle-36.png
// module id = 122
// module chunks = 0